import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-x-4 hover:bg-gray-100 px-4 py-4 sm:px-6" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "flex items-baseline justify-between gap-x-4" }




export default /*@__PURE__*/_defineComponent({
  __name: 'ListItemPluginIntegration',
  props: {
  logo: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  availabilityText: {
    type: String, default: '',
  }, // "em breve" for upcoming features
  isDisabled: {
    type: Boolean,
    default: false,
  },
  onClick: {
    type: Function,
    default: null,
  },
},
  setup(__props) {

const props = __props;

const handleClick = () => {
  if (!props.onClick || props.isDisabled) return;
  props.onClick();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass([
      props.isDisabled ? 'pointer-events-none cursor-not-allowed' : '',
      props.onClick ? 'cursor-pointer' : 'cursor-default',
    ]),
    onClick: handleClick,
    onKeyup: _withModifiers(handleClick, ["prevent"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: _normalizeClass(["size-12 flex-none", { 'grayscale opacity-50': props.isDisabled }]),
        src: __props.logo,
        alt: `${__props.title} logo`
      }, null, 10, _hoisted_2),
      _createElementVNode("div", {
        class: _normalizeClass(["flex-auto", { 'opacity-50': props.isDisabled }])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", {
            class: _normalizeClass(["text-sm/6 font-semibold", props.isDisabled ? 'text-gray-500' : 'text-gray-900'])
          }, _toDisplayString(props.title), 3),
          _createElementVNode("p", {
            class: _normalizeClass(["flex-none text-xs font-bold", props.isDisabled ? 'text-gray-500' : 'text-gray-600'])
          }, _toDisplayString(props.availabilityText), 3)
        ]),
        _createElementVNode("p", {
          class: _normalizeClass(["line-clamp-2 text-sm/6", props.isDisabled ? 'text-gray-500' : 'text-gray-600'])
        }, _toDisplayString(props.description), 3)
      ], 2)
    ])
  ], 34))
}
}

})